import React from 'react';
import { useSiteContent } from '../hooks/useSiteContent';
import './Legal.css';

const Privacy = () => {
  const { content: datenschutz, loading } = useSiteContent('datenschutz');

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  // Helper to render text with line breaks and bullet points
  const renderText = (text) => {
    if (!text) return null;
    return text.split('\n').map((line, i) => {
      // Check if line starts with bullet point
      if (line.trim().startsWith('•')) {
        return <li key={i} style={{ marginLeft: '20px', listStyleType: 'disc' }}>{line.replace('•', '').trim()}</li>;
      }
      return (
        <React.Fragment key={i}>
          {line}
          {i < text.split('\n').length - 1 && <br />}
        </React.Fragment>
      );
    });
  };

  return (
    <div className="legal-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="display-medium">Datenschutzerklärung</h1>
        </div>
      </section>

      <section className="legal-content-section">
        <div className="container">
          <div className="legal-content">
            <div className="legal-section">
              <h2 className="heading-3">1. Datenschutz auf einen Blick</h2>
              <h3 className="body-large" style={{ fontWeight: 600, marginTop: '16px' }}>Allgemeine Hinweise</h3>
              <p className="body-medium">
                {renderText(datenschutz.datenschutz_blick || 'Die folgenden Hinweise geben einen einfachen Überblick darüber, was mit Ihren personenbezogenen Daten passiert, wenn Sie diese Website besuchen. Personenbezogene Daten sind alle Daten, mit denen Sie persönlich identifiziert werden können.')}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">2. Verantwortliche Stelle</h2>
              <p className="body-medium">
                Die verantwortliche Stelle für die Datenverarbeitung auf dieser Website ist:
              </p>
              <p className="body-medium">
                {datenschutz.company_name}<br />
                {datenschutz.owner}<br />
                {datenschutz.address}<br />
                E-Mail: {datenschutz.email}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">3. Datenerfassung auf dieser Website</h2>
              <h3 className="body-large" style={{ fontWeight: 600, marginTop: '16px' }}>Kontaktformular</h3>
              <p className="body-medium">
                {renderText(datenschutz.kontaktformular || 'Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.')}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">4. Cookies</h2>
              <p className="body-medium">
                {renderText(datenschutz.cookies || 'Diese Website verwendet nur technisch notwendige Cookies. Dabei handelt es sich um kleine Textdateien, die Ihr Webbrowser auf Ihrem Endgerät speichert. Cookies helfen uns dabei, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen.')}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">5. Server-Log-Dateien</h2>
              <p className="body-medium">
                {renderText(datenschutz.server_logs || 'Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log-Dateien, die Ihr Browser automatisch an uns übermittelt.')}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">6. Google Maps</h2>
              <p className="body-medium">
                {renderText(datenschutz.google_maps || 'Diese Website nutzt den Kartendienst Google Maps. Anbieter ist die Google Ireland Limited („Google"), Gordon House, Barrow Street, Dublin 4, Irland.')}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">7. Ihre Rechte</h2>
              <p className="body-medium">
                {renderText(datenschutz.ihre_rechte || 'Sie haben jederzeit das Recht auf Auskunft über Ihre bei uns gespeicherten personenbezogenen Daten.')}
              </p>
              <p className="body-medium">
                Bei Fragen oder Beschwerden wenden Sie sich bitte an: {datenschutz.email}
              </p>
            </div>

            <div className="legal-section">
              <h2 className="heading-3">8. Speicherdauer</h2>
              <p className="body-medium">
                {renderText(datenschutz.speicherdauer || 'Soweit innerhalb dieser Datenschutzerklärung keine speziellere Speicherdauer genannt wurde, verbleiben Ihre personenbezogenen Daten bei uns, bis der Zweck für die Datenverarbeitung entfällt.')}
              </p>
            </div>

            {datenschutz.custom_text && (
              <div className="legal-section">
                <h2 className="heading-3">9. Zusätzliche Informationen</h2>
                <p className="body-medium">
                  {renderText(datenschutz.custom_text)}
                </p>
              </div>
            )}

            <div className="legal-section">
              <p className="body-small" style={{ color: 'var(--text-light)', marginTop: 'var(--spacing-large)' }}>
                Stand: Dezember 2024
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Privacy;
